import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../api"; 

const DynamicAlumniStudents = () => {
  const [alumniList, setAlumniList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(null);

  // Fetch Data from API
  useEffect(() => {
    const fetchAlumni = async () => {
      try {
        const response = await api.get("/api/alumni-students");
        
        if (response.data && response.data.status) {
          setAlumniList(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching alumni data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAlumni();
  }, []);

  // Carousel Settings for Mobile
  const mobileCarouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  // Helper to safely get image URL
  const getImageUrl = (url) => {
    if (!url) return "/assets/images/default-alumni.jpg"; 
    return url; 
  };

  // Modal Handlers
  const openModal = (index) => setSelectedIndex(index);
  const closeModal = () => setSelectedIndex(null);

  const showNext = () =>
    setSelectedIndex((prev) => (prev + 1) % alumniList.length);

  const showPrev = () =>
    setSelectedIndex((prev) => (prev - 1 + alumniList.length) % alumniList.length);

  if (loading) return null; 
  if (!alumniList.length) return null; 

  // Helper variables for current modal item
  const currentAlumni = selectedIndex !== null ? alumniList[selectedIndex] : null;

  return (
    <section className="alumni-section pt-5">
      <div className="container">
        <div className="row d-flex align-items-center justify-content-center">
          <div className="sec-title text-center">
            <h2>Our Notable Alumni</h2>
          </div>

          {/* Desktop View (Grid Layout) */}
          <div className="col-md-12 desktop-view">
            {/* Row 1: First 5 items */}
            <div className="row mb-3 d-flex justify-content-center">
              {alumniList.slice(0, 5).map((student, i) => (
                <div key={student.id} className="col-md-2">
                  <div className="single-img" onClick={() => openModal(i)}>
                    <img
                      src={getImageUrl(student.image_url)}
                      alt={student.name}
                      className="image"
                      style={{ width: "350px", height: "200px", objectFit: "cover", objectPosition: "top" }}
                    />
                    <div className="img-overlay">
                      <div className="signle-text"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Row 2: Remaining items (from index 5 onwards) */}
            {alumniList.length > 5 && (
              <div className="row justify-content-center">
                {alumniList.slice(5).map((student, i) => (
                  <div key={student.id} className="col-md-2">
                    <div className="single-img" onClick={() => openModal(i + 5)}>
                      <img
                        src={getImageUrl(student.image_url)}
                        alt={student.name}
                        className="image"
                        style={{ width: "350px", height: "200px", objectFit: "cover", objectPosition: "top" }}
                      />
                      <div className="img-overlay">
                        <div className="signle-text"></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Mobile View (Carousel Layout) */}
          <div className="col-md-12 mobile-view">
            <Slider {...mobileCarouselSettings}>
              {alumniList.map((student, i) => (
                <div key={student.id}>
                  <div className="single-img" onClick={() => openModal(i)}>
                    <img
                      src={getImageUrl(student.image_url)}
                      alt={student.name}
                      className="image w-100"
                      style={{ height: "200px", objectFit: "cover", objectPosition: "top" }}
                    />
                    <div className="img-overlay">
                      <div className="signle-text"></div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          {/* Modal */}
          {currentAlumni && (
            <div
              className="modal fade show"
              style={{ display: "block", background: "rgba(0,0,0,0.6)" }}
            >
              <div className="modal-dialog modal-md modal-dialog-centered alumni-modal-dialog">
                <div className="modal-content position-relative alumni-modal-content">
                  
                  <button
                    type="button"
                    className="alumni-icon close-icon alumni-close-btn"
                    onClick={closeModal}
                  >
                    <i className="fa fa-times"></i>
                  </button>

                  <div className="modal-body text-center position-relative alumni-modal-body">
                    
                    <button
                      className="alumni-icon side-arrow left-arrow alumni-arrow left"
                      onClick={showPrev}
                    >
                      <i className="fa fa-chevron-left"></i>
                    </button>

                    <div className="alumni-content alumni-modal-wrapper">
                      {/* 1. Image */}
                      <img
                        src={getImageUrl(currentAlumni.image_url)}
                        className="img-fluid mb-3 alumni-modal-image"
                        alt={currentAlumni.name}
                      />
                      
                      {/* 2. Name */}
                      <h5 className="alumni-modal-name">
                        {currentAlumni.name}
                      </h5>
                      
                      {/* 3. Description (Only if exists) */}
                      {currentAlumni.description && (
                        <p
                          className="alumni-modal-details"
                          dangerouslySetInnerHTML={{
                            __html: currentAlumni.description,
                          }}
                        ></p>
                      )}

                      {/* 4. Location/City (Only if exists) - Moved Below Description */}
                      {currentAlumni.city && (
                        <p className="text-muted mb-2 fw-bold mt-2">
                          <i className="fa fa-map-marker me-1 text-danger fs-6"></i> {currentAlumni.city}
                        </p>
                      )}

                    </div>

                    <button
                      className="alumni-icon side-arrow right-arrow alumni-arrow right"
                      onClick={showNext}
                    >
                      <i className="fa fa-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </section>
  );
};

export default DynamicAlumniStudents;